module.exports = __webpack_public_path__ + "img/symbol_2.1411c644.png";